export const componentTranslations = {
    clientDashboard: {
        welcome: 'Bienvenido a BEEP',
        intro: 'La Plataforma BEEP de Conexión y Evaluación del Prestatario (Borrower Engagement & Evaluation Platform) es un sistema que CIC ha desarrollado para rastrear información esencial del cliente, principalmente a través del uso de encuestas periódicas. Esta información nos ayudará a obtener información sobre:',
        listItem1: 'El desempeño de su negocio',
        listItem2: 'El impacto de nuestros préstamos',
        listItem3: 'Su nivel de satisfacción con CIC',
        listItem4: 'Lo que podemos hacer para servirle mejor a usted y a la comunidad',
        privacyStatement:
            'Los datos que nos envía a través de esta plataforma se mantienen confidenciales y solo los revisará el personal de CIC.',
        instruction:
            '<highlight><a><strong>Visite la página de Encuestas para completar las encuestas pendientes.</strong></a></highlight> ¡Le agradecemos de antemano su cooperación!',
        questions:
            '¿Preguntas? No dude en enviarnos un correo electrónico a <highlight><emailLink>lending@cictucson.org</emailLink></highlight> o comuníquese con su Gerente de Relaciones.'
    },
    stagingEnvBanner: {
        content: 'Entorno UAT'
    },
    NumberOrNoAnswerRadioGroup: {
        tooltipLabelKey:
            'Al hacer clic en la entrada numérica se deseleccionará cualquier opción seleccionada anteriormente.'
    },
    contactsModule: {
        newContact: 'Nuevo contacto',
        editingContact: 'Editando contacto',
        toggleLabelPlural: 'Mostrar {{contactCount}} contactos registrados',
        toggleLabelSingular: 'Mostrar {{contactCount}} contacto registrado',
        description:
            'Sólo los contactos que ya han sido registrados con esta organización pueden ser seleccionados como propietarios/miembros ejecutivos del equipo. Si un propietario/miembro ejecutivo del equipo no aparece en la tabla inferior, entonces debe ser registrado. Para registrar un nuevo contacto, haga clic en "Mostrar contactos registrados", que se muestra a continuación, para expandir el módulo de contactos y, luego, haga clic en el botón "Nuevo contacto".'
    },
    loansTable: {
        newLoan: 'Nuevo préstamo'
    },
    clientsTable: {
        newClient: 'Nuevo cliente'
    },
    usersTable: {
        newUser: 'Nuevo usuario'
    },
    confirmContactsModule: {
        ownerNumber: `#{{number}}: {{name}}`
    },
    modals: {
        confirmDiscardChanges: {
            title: '¿Descartar cambios?',
            body: 'Ha realizado cambios que aún no se han guardado. ¿Está seguro de que desea descartarlos?',
            confirmCTA: 'Sí, descartar cambios'
        },
        primaryReassigned: {
            title: 'Contacto principal reasignado correctamente',
            body: 'Ha transferido correctamente el rol de contacto principal a otro contacto de esta organización. Ahora se les contactará para que rellenen ésta y futuras encuestas.'
        },
        omittedLoanGroups: {
            title: 'Grupos de préstamos omitidos de la colección',
            body: 'Algunos grupos de préstamos se omitieron de la colección de encuestas generadas. Esto puede suceder por dos razones. Se ha producido un error durante la generación de la encuesta o el rango del objetivo calculado resulta ser uno ya abarcado por una encuesta existente del mismo tipo.'
        },
        confirmDeleteContact: {
            title: '¿Eliminar contacto?',
            body: '¿Está seguro de que desea eliminar este contacto?',
            confirmCTA: 'Sí, eliminar contacto'
        },
        cannotDeleteContact: {
            title: 'Este contacto no se puede eliminar',
            body: 'Hay varias razones por las que no se puede eliminar un contacto.',
            reason1: 'Un usuario no puede eliminar su propio contacto',
            reason2: 'No se puede eliminar un contacto si es el usuario principal de una organización.',
            reason3:
                'No se puede eliminar un contacto si tiene un usuario asociado que tiene acceso a la plataforma BEEP.',
            solutions:
                'Si desea eliminar un contacto, primero vuelva a asignar el contacto principal a otra persona y revoque su acceso a BEEP haciendo clic en el botón <highlight> Revocar credenciales </highlight> (si es visible debajo de su avatar a la izquierda). Después de haber tomado estos pasos, regrese aquí y haga clic en el botón <highlight>Eliminar</highlight> nuevamente para eliminar este contacto.'
        },
        inviteUser: {
            title: '¿Enviar invitación?',
            body: 'Se enviará un correo electrónico de invitación a la siguiente dirección de correo electrónico: {{email}}',
            confirmCTA: 'Sí, enviar invitación'
        },
        revokeCredentials: {
            title: '¿Revocar credenciales?',
            body: 'El acceso a la plataforma BEEP será revocado para el siguiente correo electrónico: {{email}}',
            confirmCTA: 'Sí, revocar acceso'
        },
        saveDirty: {
            title: 'Cambios no guardados',
            body: 'Está intentando navegar a otra sección del formulario mientras tiene cambios sin guardar. Para cerrar este mensaje y revisar esta sección del formulario nuevamente, haga clic en <highlight>Aceptar</highlight>. Cuando esté satisfecho, haga clic en el botón <highlight>Guardar y continuar</highlight>. Si desea descartar los cambios sin guardar y navegar, simplemente haga clic en el botón <highlight>Descartar cambios no guardados</highlight>.',
            confirmCTA: 'Guardar y proceder'
        },
        enrollOrg: {
            title: '¿Inscribir al cliente en encuestas?',
            body: 'Una vez que un cliente se haya inscrito, recibirá notificaciones por correo electrónico sobre las encuestas que están listas para su atención. ¿Está listo para inscribir a este cliente ahora?',
            confirmCTA: 'Sí, inscribir al cliente'
        },
        confirmEmail: {
            title: 'Confirmar correo electrónico de inicio de sesión',
            body: 'Proporcione su correo electrónico para la confirmación'
        }
    },
    endingSlide: {
        youreAllSet: '¡Listo!',
        actions: {
            continueToDashboard: 'Continuar al tablero',
            returnToSurveys: 'Volver a las encuestas'
        }
    },
    confirmPrimaryContactSlide: {
        name: 'Confirmar contacto principal',
        description:
            'Antes de comenzar la encuesta, confirme que es el contacto principal de esta organización. De lo contrario, asigne un contacto principal diferente en el campo desplegable a continuación.',
        description2:
            "Si necesita editar un contacto o crear uno nuevo, haga clic en 'Mostrar contactos registrados' a continuación para expandir el módulo de contactos, luego haga clic en el botón 'Nuevo contacto'.",
        modal: {
            title: '¿Está seguro?',
            body: 'La persona identificada como Contacto principal es la única persona que puede proporcionar o actualizar información en nombre de una organización. Al continuar, reconoce que perderá inmediatamente la capacidad de continuar con este formulario.',
            confirmCTA: 'Sí, cambiar contacto principal'
        }
    },
    tables: {
        common: {
            resultsPerPage: 'resultados por página',
            clearFilters: 'Borrar todos los filtros',
            defaultSearchPlaceholder: 'Buscar...'
        },
        clients: {
            columns: {
                name: 'Nombre',
                dba: 'Hacer negocios como',
                relationshipManager: 'Gerente de relación',
                primaryContact: 'Contacto principal',
                isOkayToContact: '¿Está bien contactar?',
                hasActiveLoan: '¿Tiene un préstamo activo?'
            }
        },
        contacts: {
            columns: {
                name: 'Nombre del contacto',
                organization: 'Nombre del cliente/organización',
                primaryPhone: 'Teléfono principal',
                primaryEmail: 'Correo electrónico principal',
                isOkayToContact: '¿Está bien contactar?'
            }
        },
        loans: {
            columns: {
                loanNumber: 'No. de préstamo',
                organization: 'Nombre del cliente/org',
                approvedLoanAmount: 'Monto aprobado',
                settlementDate: 'Fecha de liquidación',
                terminationDate: 'Fecha de terminación',
                loanOfficer: 'Gestor de préstamos',
                loanProgram: 'Programa de préstamos'
            }
        },
        loanGroups: {
            columns: {
                name: 'Nombre',
                originDate: 'Fecha de origen',
                groupFinancingTotal: 'Monto total',
                enrolled: '¿Está inscrito?'
            },
            rightControlLabel: 'Nuevo grupo de préstamos',
            drawer: {
                title: {
                    new: 'Nuevo grupo de préstamos',
                    edit: 'Editando grupo de préstamos'
                }
            }
        },
        surveys: {
            columns: {
                type: 'Tipo',
                organization: 'Nombre del cliente/organización',
                relationshipManager: 'Gerente de relaciones',
                status: 'Estado',
                createdAt: 'Creado en',
                dateSent: 'Fecha de envío',
                reminderSent: 'Recordatorio enviado',
                loanGroup: 'Grupo de préstamos',
                reasonOmitted: 'Motivo omitido',
                updatedAt: 'Actualizado en',
                id: 'ID'
            }
        },
        users: {
            columns: {
                authEmail: 'Correo electrónico de autenticación',
                organization: 'Nombre del cliente/organización',
                name: 'Nombre',
                role: 'Función'
            }
        }
    },
    cards: {
        client: {
            header: 'Detalles del cliente',
            alert: {
                onboarding: {
                    title: 'Incorporación Pendiente',
                    body: 'El cliente ha sido inscrito, sin embargo, el Contacto Primario asociado aún no ha visitado BEEP.<br /><br />Primera Invitación Enviada: {{firstSent}}<br />Última Invitación Enviada: {{lastSent}}'
                },
                readOnly: {
                    title: 'Edición deshabilitada',
                    body: 'No se permite editar mientras esta organización tiene una encuesta activa en progreso.'
                }
            },
            drawer: {
                title: 'Editando cliente'
            }
        },
        contact: {
            header: 'Detalles del contacto',
            drawer: {
                title: 'Editando contacto'
            }
        },
        loan: {
            header: 'Detalles del préstamo',
            drawer: {
                title: 'Editando préstamo'
            }
        },
        user: {
            header: 'Detalles del usuario',
            drawer: {
                titleEditing: 'Editando usuario',
                titleNew: 'Nuevo usuario'
            }
        },
        surveyBatch: {
            drawer: {
                title: {
                    batch: 'Generate Survey Batch',
                    single: 'Generate Survey'
                },
                body: {
                    biannual: {
                        batch: 'Biannual surveys are generated in batches. All clients who have <highlight><i>not</i></highlight> received a survey of the type(s) selected in the <highlight>Considered Past Surveys</highlight> field in the form below, within the selected <highlight>Time Period</highlight> leading up to today, will have a new biannual survey generated for them.',
                        single: 'On submission of this form, a survey will be generated for this client if they have <highlight><i>not</i></highlight> received a survey of the type(s) selected in the <highlight>Considered Past Surveys</highlight> field in the form below, within the selected <highlight>Time Period</highlight> leading up to today.'
                    },
                    financial: {
                        batch: 'Financial surveys are generated in batches. All clients who have <highlight><i>not</i></highlight> received a financial survey for the chosen target year will have a new one generated for them.',
                        single: 'On submission of this form, a financial survey will be generated for this client if they have <highlight><i>not</i></highlight> already received one for the chosen target year.'
                    }
                }
            }
        }
    },
    infoTables: {
        name: 'Nombre',
        pronouns: 'Pronombres',
        suffix: 'Sufijo',
        honorific: 'Tratamiento',
        gender: 'Género',
        email: 'Correo electrónico',
        primaryEmail: 'Correo electrónico principal',
        secondaryEmail: 'Correo electrónico secundario',
        phone: 'Teléfono',
        primaryPhone: 'Teléfono principal',
        homePhone: 'Teléfono de casa',
        mobilePhone: 'Teléfono móvil',
        portfolId: 'ID de Portfol',
        race: 'Raza',
        isOkayToContact: '¿Está bien contactar?',
        isNonProfit: '¿Es una organización sin fines de lucro?',
        hasActiveLoan: '¿Tiene un préstamo activo?',
        loanNumber: 'Número de préstamo',
        loanOfficer: 'Gestor de préstamos',
        approvedLoanAmount: 'Monto de préstamo aprobado',
        effectiveDateOfTermination: 'Fecha de terminación',
        actualSettlementDate: 'Fecha de liquidación real',
        isClosed: '¿Está cerrado?',
        isActive: '¿Está activo?',
        organizationName: 'Nombre de la organización',
        createdAt: 'Creado en',
        updatedAt: 'Actualizado en',
        clientNumber: 'Número de cliente',
        relationshipManager: 'Gerente de relaciones',
        businessName: 'Nombre del negocio',
        daysAfterFiscalYearEnd: 'Días después que termina el año fiscal en que se debe presentar el informe ',
        businessType: 'Tipo de negocio',
        yearEstablished: 'Fecha de constitución',
        formOfOrg: 'Forma de organización',
        monthFiscalYearEnds: 'Mes en que termina el año fiscal',
        typeOfBusiness: 'Tipo de negocio',
        ein: 'EIN',
        dba: 'Hacer negocios como',
        primaryContact: 'Contacto principal',
        contact: 'Contacto asociado',
        disabled: '¿Tiene discapacidad?',
        firebaseEmail: 'Correo electrónico de autenticación',
        firebaseId: 'ID de autenticación',
        organization: 'Organización',
        hasSignedAgreement: '¿Firmó el acuerdo?',
        cicRole: 'Papel de CIC',
        orgRole: 'Papel la organización'
    },
    inputValueTable: {
        tooltips: {
            otherExpenses:
                "El monto de 'Otros gastos' se genera automáticamente para contabilizar la diferencia entre el monto total y la suma de cada partida proporcionada. No se puede editar manualmente y se eliminará automáticamente de la tabla una vez que los totales de la partida coincidan con el total declarado.",
            consolidateTotal: 'Calcular el total en función de las partidas proporcionadas.'
        },
        placeholders: {
            label: 'Ingrese descripción...',
            amount: 'Ingrese monto...'
        },
        errors: {
            totalTooLow: 'El monto total no puede ser menor que la suma de los montos enumerados.'
        }
    },
    buttons: {
        seeMore: 'Ver más',
        seeLess: 'Ver menos'
    },
    wageRanger: {
        title: 'Rango Salarial',
        employee: {
            assignedProgress: '<strong>{{unassigned}}</strong> de <strong>{{total}}</strong> empleados sin asignar',
            allAssigned: 'Todos los <strong>{{total}}</strong> empleados han sido asignados.',
            tooMany:
                'Ha asignado <strong>{{excess}}</strong> demasiados empleados. El número total de empleados debe ser igual a <strong>{{total}}</strong>.'
        },
        contractor: {
            assignedProgress: '<strong>{{unassigned}}</strong> de <strong>{{total}}</strong> contratistas sin asignar',
            allAssigned: 'Todos los <strong>{{total}}</strong> contratistas han sido asignados.',
            tooMany:
                'Ha asignado <strong>{{excess}}</strong> demasiados contratistas. El número total de contratistas debe ser igual a <strong>{{total}}</strong>.'
        },
        rangeLabelPrefix: 'Nivel {{index}}',
        total: 'Total',
        fullTime: 'Tiempo completo',
        partTime: 'Tiempo parcial',
        fullPart: 'Tiempo completo/parcial'
    },
    wageRangeChart: {
        xAxis: 'Rango salarial',
        yAxis: 'Numero de empleados',
        title: 'Gráfico de salarios/sueldos'
    },
    formStepper: {
        inactiveStepTooltip: 'La sección del formulario no es relevante según las respuestas anteriores.'
    },
    reviewAnswers: {
        title: 'Revisar y enviar',
        body: 'Revise sus respuestas en la tabla de resumen a continuación. Si desea realizar cambios, haga clic en la pregunta y volverá a esa respuesta. Si todo se ve bien, simplemente haga clic en "Enviar"!'
    },
    providerButtons: {
        google: 'Iniciar sesión con Google',
        microsoft: 'Iniciar sesión con Microsoft'
    },
    emailLogin: {
        message:
            'Ingrese el correo electrónico con el que se registró en CIC y haga clic en el botón de abajo. Luego, se le enviará un enlace para iniciar sesión.',
        toAdmin: 'Si es de CIC, inicie sesión <a>aquí</a>.',
        toClient: 'Si es cliente de CIC, inicie sesión <a>aquí</a>.'
    },
    changeSurveyStatusButton: {
        buttonLabel: 'Aprobar o rechazar',
        radio: {
            title: 'Seleccionar una acción',
            options: {
                approve: 'Aprobar',
                reject: 'Rechazar'
            }
        },
        textarea: {
            label: 'Comentarios del cliente',
            placeholder: 'Deje algún comentario para el cliente aquí...'
        },
        modal: {
            title: 'Revisar envío',
            highlightedQuestions: 'Ha seleccionado {{questionCount}} pregunta(s) para que el cliente revise'
        }
    },
    returnSurveyToSubmittedButton: {
        buttonLabel: 'Reabrir Encuesta',
        modal: {
            title: '¿Reabrir Encuesta?',
            body: "Al reabrir la encuesta, volverá al estado 'Enviada.' A partir de ahí, se puede revisar y devolver al cliente para que realice cambios adicionales. ¿Desea continuar?",
            confirmCTA: 'Si, Reabrir Encuesta'
        },
        notifications: {
            success: {
                title: 'Esta encuesta se ha reabierto.'
            },
            fail: {
                title: 'Hubo un error al reabrir esta encuesta.'
            }
        }
    },
    surveyNotesButton: {
        buttonLabel: 'Ver notas de la encuesta',
        modal: {
            title: 'Notas de la encuesta'
        },
        noteType: {
            APPROVE: 'Aprobado',
            REJECT: 'Rechazado',
            NOTE_INTERNAL: 'Nota interna',
            NOTE_EXTERNAL: 'Nota externa'
        }
    },
    latestReviewNote: {
        guidance:
            'Navegue hasta las preguntas/secciones resaltadas en naranja y realice los ajustes necesarios. Tenga en cuenta que algunos cambios solicitados pueden estar en unas pocas páginas dentro de una sección; si no ve los resaltados naranjas de inmediato, haga clic en <highlight>Guardar y continuar</highlight> para llegar allí.',
        type: {
            REJECT: 'Requiere ajuste'
        }
    },
    accountSettings: {
        fields: {
            name: {
                label: 'Nombre',
                placeholder: 'Tu nombre...'
            },
            email: {
                label: 'Correo electrónico',
                description:
                    'Este es el correo electrónico que usa para iniciar sesión en la plataforma BEEP. Una vez cambiado, deberá usar el nuevo correo electrónico al iniciar sesión.',

                disabledDescription:
                    'Este es el correo electrónico que usa para iniciar sesión en la plataforma BEEP. Los usuarios de CIC no pueden cambiar el correo electrónico de autenticación.',
                placeholder: 'El correo electrónico con el que desea iniciar sesión...'
            },
            preferredLang: {
                label: 'Idioma preferido'
            }
        }
    },
    loanGroupForm: {
        fields: {
            name: {
                label: 'Nombre del grupo de préstamos',
                placeholder: '...'
            },
            loans: {
                label: 'Préstamos incluidos',
                description:
                    'No se pueden incluir préstamos con una fecha de liquidación anterior a la fecha de origen de este grupo de préstamos',
                placeholder: 'Seleccione uno o más'
            },
            enrolled: {
                label: 'Inscrito',
                placeholder: ''
            },
            originDate: {
                label: 'Fecha de origen',
                placeholder: ''
            },
            groupFinancingTotal: {
                label: 'Total de financiamiento grupal',
                placeholder: ''
            },
            notes: {
                label: 'Notas',
                placeholder: 'Deje aquí cualquier nota para los usuarios de CIC...'
            }
        }
    },
    createSurveyForm: {
        fields: {
            targetSurveys: {
                label: 'Encuestas pasadas consideradas',
                placeholder: '...'
            },
            targetWindow: {
                label: 'Período de tiempo',
                placeholder: 'Seleccione un marco de tiempo...'
            }
        }
    },
    usersTables: {
        cicUsers: 'Usuarios de CIC',
        allUsers: 'Todos los usuarios'
    },
    userCard: {
        rolesFieldLabel: 'Roles de usuario',
        roles: {
            ORG_USER: 'Usuario de la organización',
            ORG_PRIMARY: 'Usuario principal de la organización',
            CIC_USER: 'Usuario de CIC',
            CIC_ADMIN: 'Administrador de CIC',
            CIC_OWNER: 'Superadministrador de CIC'
        }
    },
    onboardingModal: {
        title: 'Incorporación',
        begin: 'Haga clic en el botón de abajo para comenzar la encuesta de incorporación para esta organización',
        continue: 'Haga clic en el botón de abajo para continuar la encuesta de incorporación para esta organización'
    },
    mustOnboardAlert: {
        title: 'La incorporación está incompleta',
        body: 'El contacto principal de sus organizaciones debe completar el proceso de incorporación antes de que cualquier otro miembro de dicha organización pueda usar la plataforma BEEP'
    },
    userRoleLabels: {},
    clientCard: {
        enrollAlert: {
            primaryContactRequired:
                'Para inscribir a este cliente en encuestas, primero debe asignar un contacto principal. Para hacer esto: <br><br> 1. Seleccione la <highlight>pestaña Contactos</highlight> en la tarjeta de la parte inferior de esta página<br> 2. Haga clic en el botón <highlight>+ Nuevo contacto</highlight><br> 3. Complete el formulario de detalles del contacto y haga clic en <highlight>Guardar y terminar</highlight><br> 4. Luego, haga clic en <highlight>Editar</highlight> en la tarjeta <highlight>Detalles del cliente</highlight><br> 5. Seleccione el contacto recién creado en el menú desplegable de contacto principal y haga clic en <highlight>Guardar y terminar</highlight><br><br>',
            default:
                "Revise la información del cliente a continuación y realice los ajustes necesarios. Una vez que esté satisfecho de que estén listos para comenzar a usar la plataforma BEEP, haga clic en el botón 'Inscribir' y nos comunicaremos con su contacto principal para inicializar el proceso de incorporación."
        }
    },
    surveyBatch: {
        cta: 'Generar encuestas semestrales'
    },
    sendSurveyButton: {
        cta: 'Enviar encuesta',
        modal: {
            title: '¿Enviar encuesta?',
            body: 'Una vez enviada, se notificará al contacto principal de esta organización y podrá comenzar a completar la encuesta. ¿Desea continuar?',
            confirmCTA: 'Sí, enviar encuesta'
        }
    },
    sendReminderButton: {
        cta: 'Enviar recordatorio',
        modal: {
            title: '¿Enviar recordatorio?',
            reminderSent: 'Último recordatorio enviado el {{reminderSentDate}}',
            body: 'Esto enviará una notificación por correo electrónico al contacto principal del cliente, recordándole que complete esta encuesta. ¿Desea continuar?',
            confirmCTA: 'Sí, enviar recordatorio'
        }
    },
    warnAboutMobileStyles: {
        modal: {
            title: 'Estilos móviles aún no optimizados',
            body: 'Para una experiencia más fluida, recomendamos usar la plataforma BEEP en una computadora de escritorio/portátil o tableta. Aún no se han implementado correctamente los estilos móviles, por lo que es posible que encuentre problemas al usarla en un dispositivo móvil.'
        }
    },
    deleteSurveyButton: {
        modal: {
            title: '¿Eliminar encuesta?',
            body: {
                onboarding:
                    'Una vez eliminada, se restablecerá el estado de incorporación del cliente. Cuando el contacto principal de esta organización vuelva a iniciar sesión, se generará una nueva encuesta de incorporación y se le enviará.',
                intake: 'Una vez eliminada, se puede generar una nueva encuesta de incorporación abriendo el formulario de detalles del grupo de préstamos asociado, cambiando el botón de opción <highlight>Inscrito</highlight> a <highlight>No</highlight> y guardando, luego volviendo a abrir el mismo formulario y cambiando <highlight>Inscrito</highlight> nuevamente a <highlight>Sí</highlight>. Al reinscribir un grupo de préstamos de esta manera, se genera una nueva encuesta de incorporación.',
                biannual:
                    'Una vez eliminada, esta encuesta ya no estará disponible para enviarla al cliente hasta que se genere una nueva colección de encuestas.'
            },
            confirmCTA: 'Sí, eliminar encuesta'
        }
    },
    loanGroupSurveysSummary: {
        title: 'Encuestas en este grupo de préstamos'
    },
    surveyReview: {
        alert: 'Si nota datos incorrectos o incompletos en la encuesta enviada, antes de rechazar el envío, haga clic en las preguntas del problema para seleccionarlas y resaltarlas. Cuando se rechaza una encuesta, se devuelve al cliente para que pueda realizar las modificaciones necesarias. Cualquier pregunta que haya seleccionado el revisor antes de rechazar el envío se resaltará para el cliente, lo que le facilitará saber qué preguntas requieren una segunda revisión.<br/><br/>Además, después de hacer clic en "Aprobar o rechazar", proporcione información detallada (por ejemplo, los datos que completaron) en el cuadro Comentarios para el cliente. Esto no solo ayudará al cliente, sino que le ayudará a recordar qué cambios buscar al revisar la nueva información enviada.'
    },
    adminExport: {
        title: 'Preparar exportación',
        description: 'Seleccione en la siguiente lista los conjuntos de datos que desea incluir en la exportación.',
        notifications: {
            success: {
                title: '¡Exportación completada!',
                description: 'Descargando ahora...'
            },
            fail: {
                title: '¡Error de exportación!',
                description: '¡Hubo un error al exportar los datos solicitados!'
            }
        },
        noPermission: {
            title: 'La función de exportación no está disponible.',
            description:
                'Solo los superadministradores de CIC están autorizados a crear y descargar datos de exportación.'
        }
    }
};
